export function childAgeCSVStringToNumberArray(ageString: string): number[] {
  return ageString
    .split(',')
    .map((age) => parseInt(age, 10))
    .filter((age) => !isNaN(age))
}
